// extracted by mini-css-extract-plugin
module.exports = {"Flip":"Flip_Flip__1psIJ","PuzzleContainer":"Flip_PuzzleContainer__1lzrk","Cell":"Flip_Cell__2cIuA","Highlight":"Flip_Highlight__3Oc8q"};